import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout/Layout";
import { routes } from "./routes/routesConfig";
import "./App.css";
  
function App() {
  return (
    <Router>
      <Layout>
        <div className="charts-container">
          <Routes>
            {routes.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Layout>
    </Router> 
  );
}

export default App;


